/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Upgrade({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g fill="currentColor" clipPath="url(#Upgrade_svg__a)"><path d="M8.569 1.331a.6.6 0 0 0-1.2 0v.9a.6.6 0 1 0 1.2 0zM8.569 13.769a.6.6 0 1 0-1.2 0v.9a.6.6 0 0 0 1.2 0zM15.238 8a.6.6 0 0 1-.6.6h-.9a.6.6 0 1 1 0-1.2h.9a.6.6 0 0 1 .6.6M2.2 8.6a.6.6 0 0 0 0-1.2h-.9a.6.6 0 1 0 0 1.2zM13.109 2.86a.6.6 0 0 1 0 .849l-.637.636a.6.6 0 0 1-.848-.848l.636-.637a.6.6 0 0 1 .849 0M4.314 12.503a.6.6 0 1 0-.849-.848l-.636.636a.6.6 0 1 0 .849.849zM13.109 13.14a.6.6 0 0 1-.849 0l-.636-.637a.6.6 0 1 1 .848-.848l.637.636a.6.6 0 0 1 0 .849M3.465 4.345a.6.6 0 0 0 .849-.848l-.636-.637a.6.6 0 0 0-.849.849zM5.708 7.447a.6.6 0 0 1 .037-.848l1.818-1.666a.6.6 0 0 1 .811 0l1.818 1.666a.6.6 0 0 1-.81.885l-.814-.745v3.886a.6.6 0 1 1-1.2 0V6.739l-.812.745a.6.6 0 0 1-.848-.037" /></g><defs><clipPath id="Upgrade_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;